import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import { Tutor } from 'src/app/models/tutor';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-tutors-form',
  templateUrl: './tutors-form.component.html',
  styleUrls: ['./tutors-form.component.scss'],
})
export class TutorsFormComponent implements OnInit, OnChanges {
  readonly VALIDATOR = [
    Validators.required,
    Validators.email,
    Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
  ];

  @Input()
  showReminder: boolean;

  @Input()
  showDescription: boolean;

  @Input()
  tutors: Tutor[] = [];

  @Output()
  submitted: EventEmitter<any> = new EventEmitter();

  @Output()
  dismissed: EventEmitter<boolean> = new EventEmitter();

  tutorsForm: UntypedFormGroup;
  textDirection: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
    this._init(this.tutors);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tutors && changes.tutors.currentValue) {
      this._init(changes.tutors.currentValue as Tutor[]);
    }
  }

  get tutorsEmails(): UntypedFormArray {
    return this.tutorsForm.get('emails') as UntypedFormArray;
  }

  addTutorEmail(_email?: string, _id?: number) {
    this.tutorsEmails.push(
      this.formBuilder.group({
        email: [_email || '', this.VALIDATOR],
        id: _id,
      })
    );
  }

  deleteTutorEmail(index: number) {
    this.tutorsEmails.removeAt(index);
  }

  submit() {
    this.submitted.emit(this.tutorsForm.value);
  }

  dismiss() {
    this.dismissed.emit(true);
  }

  private _init(tutors: Tutor[]) {
    if (!tutors.length) {
      tutors.push({ tutorMail: '', id: null });
    }

    this.tutorsForm = this.formBuilder.group({
      emails: this.formBuilder.array(
        tutors.map((t) =>
          this.formBuilder.group({
            email: [t.tutorMail, this.VALIDATOR],
            id: t.id,
          })
        )
      ),
    });

    this.tutors = tutors;
  }
}
